'use strict';
import {environment} from "../environments/environment";

const BASE_URL = environment.baseUrl;

export const UPLOAD_FILE_ENDPOINT= BASE_URL + '/v1/insurance/admin/uploadsales';
export const CREATE_USER_ENDPOINT= BASE_URL + '/v1/insurance/user/createuser';
export const DOWNLOAD_REPORT_ENDPOINT_GET= BASE_URL + '/v1/insurance/admin/downloadreport';
export const DOWNLOAD_REPORT_ENDPOINT_POST= BASE_URL + '/v1/insurance/admin/postdownloadreport';
export const AUTHENTICATION_ENDPOINT: string= BASE_URL + '/v1/insurance/user/authenticateuser';
export const DOWNLOAD_REPORT_PACKAGE_ENDPOINT_POST= BASE_URL + '/v1/insurance/admin/postdownloadreportpackage';

export const LOCALHOST= environment.frontendUrl;






// WEBPACK FOOTER //
// ./src/app/endpoints.ts